module.exports = __webpack_public_path__ + "static/media/spotify-01.4be4364b.png";